import React from 'react';
import { RouteObject } from 'react-router-dom';

import RHIVersionGate from '@/components/RetailHealthInsurance/RHIVersionGate';

import DisableTextSelectionWrapper from '@/components/Common/Wrapper/DisableTextSelectionWrapper';
import BaseHealthInsurance from '@/pages/health-insurance/BaseHealthInsurance';

const PlansBenefits = React.lazy(
  () => import('@/pages/health-insurance/plans-benefits/index'),
);
const RetailHealthRecommendation = React.lazy(
  () => import('@/pages/health-insurance/recommendation/index'),
);
const RetailHealthSelectMember = React.lazy(
  () => import('@/pages/health-insurance/select-member'),
);
const RetailHealthInsuranceHome = React.lazy(
  () => import('@/pages/health-insurance/home/index'),
);
const ThankYou = React.lazy(
  () => import('@/pages/health-insurance/thank-you/index'),
);
const RHIError = React.lazy(
  () => import('@/pages/health-insurance/error/index'),
);
const AddRiders = React.lazy(
  () => import('@/pages/health-insurance/add-riders/[insurer]'),
);
const MemberDetails = React.lazy(
  () => import('@/pages/health-insurance/member-details/index'),
);
const MemberDetailsForm = React.lazy(
  () => import('@/pages/health-insurance/member-details/[relation]'),
);

const VerifyDetails = React.lazy(
  () => import('@/pages/health-insurance/verify-details/index'),
);

const AddNominee = React.lazy(
  () => import('@/pages/health-insurance/add-nominee/index'),
);

const BankDetails = React.lazy(
  () => import('@/pages/health-insurance/bank-details/index'),
);

const Checkout = React.lazy(
  () => import('@/pages/health-insurance/checkout/index'),
);

const RetailHealthPolicyStatus = React.lazy(
  () => import('@/pages/health-insurance/policy-status/[status].tsx'),
);

export const healthInsuranceRoutes: RouteObject[] = [
  {
    path: 'health-insurance',
    element: (
      <DisableTextSelectionWrapper>
        <BaseHealthInsurance />
      </DisableTextSelectionWrapper>
    ),
    children: [
      {
        path: '',
        element: <RetailHealthInsuranceHome />,
      },
      {
        path: 'recommendation',
        element: <RetailHealthRecommendation />,
      },
      {
        path: 'select-member',
        element: <RetailHealthSelectMember />,
      },
      {
        path: 'plans-benefits',
        element: <PlansBenefits />,
      },
      {
        path: 'thank-you',
        element: <ThankYou />,
      },
      {
        path: 'error',
        element: <RHIError />,
      },
      {
        element: <RHIVersionGate />,
        children: [
          { path: 'add-riders/:planId', element: <AddRiders /> },
          { path: 'verify-details', element: <VerifyDetails /> },
          { path: 'add-nominee', element: <AddNominee /> },
          { path: 'member-details', element: <MemberDetails /> },
          { path: 'member-details/:relation', element: <MemberDetailsForm /> },
          { path: 'checkout', element: <Checkout /> },
          { path: 'bank-details', element: <BankDetails /> },
        ],
      },
      { path: 'policy-status', element: <RetailHealthPolicyStatus /> },
      { path: 'policy-status/:status', element: <RetailHealthPolicyStatus /> },
    ],
  },
];
